/**
 * Convert each masked value of an address from asterisks to dots.
 */
export function formatAddressMasks(address) {
  if (!address) return

  const updatedAddress = {}

  for (const [key, value] of Object.entries(address)) {
    updatedAddress[key] = typeof value === 'string' ? value?.replace(/\*/g, '•') : value
  }

  return updatedAddress
}
